import axios, { AxiosInstance } from 'axios';
import { ApiRoutes } from '../../../Constants/ApiRoutingConstants';
import authorizeService from '../../Identity/Utilities/AuthorizeService';
import type {
  ApiScheduleGroupRow,
  CauseCodeUpdate,
  WorkOrdersReportRequest,
} from '../Components/WorkOrders/WorkOrdersTypes';
class WorkOrdersReportApiService {
  axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_REPORT_SERVICE_URL,
    });
  }

  async fetchWorkOrdersActions(payload: WorkOrdersReportRequest): Promise<ApiScheduleGroupRow[]> {
    const response = await this.axiosInstance({
      method: 'POST',
      url: ApiRoutes.ReportWorkOrdersActions,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: payload,
    });
    return response.data as ApiScheduleGroupRow[];
  }

  /** Assign or clear Cause Codes on work order actions (empty `causeCode` clears). */
  async updateActionCauseCodes(updates: CauseCodeUpdate[]): Promise<void> {
    await this.axiosInstance({
      method: 'PATCH',
      url: ApiRoutes.ReportWorkOrdersCauseCodes,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: { updates },
    });
  }

  static get instance() {
    return workOrdersReportApiService;
  }
}

const workOrdersReportApiService = new WorkOrdersReportApiService();
export default workOrdersReportApiService;
